var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownBlackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3018 0.281442L6 4.58306L1.69815 0.281213V0.281437C1.44362 0.0356221 1.07837 -0.0578721 0.73705 0.0356212C0.395955 0.129338 0.129355 0.395955 0.0356214 0.73705C-0.0578719 1.07837 0.0356213 1.44363 0.281436 1.69815L5.29164 6.70836C5.47952 6.89624 5.73429 7.00181 6 7.00181C6.26571 7.00181 6.52048 6.89624 6.70836 6.70836L11.7186 1.69815C11.9644 1.44362 12.0579 1.07837 11.9644 0.73705C11.8707 0.395955 11.604 0.129355 11.2629 0.0356212C10.9216 -0.0578721 10.5564 0.0356221 10.3018 0.281437V0.281442Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownBlackArrow);
export default __webpack_public_path__ + "static/media/down-black-arrow.274a0439398f0206cc113a8c6eebec1a.svg";
export { ForwardRef as ReactComponent };